import { render, staticRenderFns } from "./taskDespatchOrderDataTable.vue?vue&type=template&id=b7657cfa&"
import script from "./taskDespatchOrderDataTable.vue?vue&type=script&lang=js&"
export * from "./taskDespatchOrderDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports